function tokenPaymentComplete(token) {
	const date =
		new Date(token[token.length - 1].created_at).toDateString() +
		" " +
		new Date(token[token.length - 1].created_at).toLocaleTimeString([], {
			hour: "2-digit",
			minute: "2-digit",
		});
	return date;
}

function numberWithCommas(x) {
	x = x ? Math.round(x) : x;
	return x?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ",");
}

export { tokenPaymentComplete, numberWithCommas };
